import Swiper from 'swiper';
import {
	Navigation,
	Pagination,
	Autoplay,
	EffectFade,
	Scrollbar,
	Mousewheel,
} from 'swiper/modules';

Swiper.use([
	Pagination,
	Navigation,
	Autoplay,
	EffectFade,
	Scrollbar,
	Mousewheel,
]);

// @import "./node_modules/swiper/swiper";
// @import "./node_modules/swiper/modules/effect-fade/effect-fade";

// import 'swiper/swiper-bundle.css';

import { lazyLoadImages, lazyLoadVideos, initializeButtonEffect } from './functions.js';

const swiperSliderTestimonials = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {
        let nearestSlider = slider.closest('section');
		const pagination = slider.querySelector('.swiper-pagination');
        const prev = nearestSlider.querySelector('.swiper-button-prev');
        const next = nearestSlider.querySelector('.swiper-button-next');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		// console.log('slidescount:' + slidesCount);

		const swiper = new Swiper(slider, {
			modules: [Autoplay, Pagination, Navigation],
			loop: true,
			pagination: {
				el: slidesCount > 1 ? pagination : null,
				clickable: true,
			},
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
			speed: 150,
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			spaceBetween: 44,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			},
		});
	});
};
swiperSliderTestimonials('.swiper-slider-testimonials');

const swiperSliderRelated = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {
        let nearestSlider = slider.closest('section');
		const pagination = slider.querySelector('.swiper-pagination');
		const scrollbar = slider.querySelector('.swiper-scrollbar');
        const prev = nearestSlider.querySelector('.swiper-button-prev');
        const next = nearestSlider.querySelector('.swiper-button-next');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		// console.log('slidescount:' + slidesCount);

		const swiper = new Swiper(slider, {
			modules: [Autoplay, Navigation],
			loop: true,
            // centeredSlides: true,
			pagination: {
				el: slidesCount > 1 ? pagination : null,
				clickable: true,
			},
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
			speed: 600,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			spaceBetween: 40,
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 3,
				},
			},
		});
	});
};
swiperSliderRelated('.swiper-slider-related');

const swiperSliderLogos = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);

	swiperSliders.forEach((slider) => {
		// Skip initialization if the slider has the 'disabled' attribute
		if (slider.hasAttribute('disabled')) {
			return;
		}

		// Get nearest slider section and count slides
		let nearestSlider = slider.closest('section');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		// Initialize Swiper
		const swiper = new Swiper(slider, {
			modules: [Autoplay],
			loop: true,
			speed: 3500,
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
			},
			freeMode: true,
			spaceBetween: 40,
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 5,
				},
			},
		});
	});
};
swiperSliderLogos('.swiper-slider-logos');









class ImagePopup {
    constructor(options = {}) {
        const defaultOptions = {
            popupSelector: '.popup',
            popupImageSelector: 'img',
            closeButtonSelector: '.popup-close',
            // linkSelector: '.swiper-slide a',
            linkSelector: '.swiper-slider-gallery .swiper-slide a',
            swiperInstance: '.swiper-slider-gallery',
            keyboardNavEnabled: true,
            enableNav: true,
            dataCursorText: 'Enlarge',
            autoplayPauseDuration: 5000
        };

        // options
        this.options = { ...defaultOptions, ...options };
        this.swiper = this.options.swiperInstance || false;
        this.autoplayEnabled = this.options.autoplay || false; // Store the autoplay state
        this.autoplayValue = this.options.autoplayValue || 0; // Store the autoplay interval
        this.keyboardNavEnabled = this.options.keyboardNavEnabled || false;
        this.dataCursorText = this.options.dataCursorText || null;
        this.autoplayPauseDuration = this.options.autoplayPauseDuration || 5000;

        // modal + selectors
        this.createPopup();
        this.popup = document.querySelector(this.options.popupSelector) || null;
        this.popupImage = this.popup.querySelector(this.options.popupImageSelector) || null;
        this.closeButton = this.popup.querySelector(this.options.closeButtonSelector) || null;
        this.nextButton = this.popup.querySelector('.popup-next') || null;
        this.prevButton = this.popup.querySelector('.popup-prev') || null;

        if (this.popup && this.popupImage && this.closeButton && this.swiper) {
            this.init();
        } else {
            console.error('ImagePopup: Required elements or Swiper instance not found.');
        }

        // For swipe detection
        this.touchStartX = 0;
        this.touchEndX = 0;
    }

    init() {
        // defaultOptions.swiperInstance.el.querySelectorAll(this.options.linkSelector).forEach((link) => {
        document.querySelectorAll(this.options.linkSelector).forEach((link) => {
            link.addEventListener('click', (event) => this.openPopup(event));
        });

        this.closeButton.addEventListener('click', this.closePopup.bind(this));
        this.popup.addEventListener('click', this.handleBackgroundClick.bind(this));

        // Initialize next and previous buttons
        this.nextButton = this.popup.querySelector('.popup-next');
        this.prevButton = this.popup.querySelector('.popup-prev');

        // Event listeners for buttons
        this.nextButton.addEventListener('click', this.showNextImage.bind(this));
        this.prevButton.addEventListener('click', this.showPreviousImage.bind(this));

        // Listen to Swiper's slide change to update the modal's image
        this.swiper.on('slideChange', () => this.updatePopupImage());

        // Adding swipe functionality to the image
        this.popupImage.addEventListener('touchstart', this.handleTouchStart.bind(this));
        this.popupImage.addEventListener('touchend', this.handleTouchEnd.bind(this));

        // Add keyboard navigation if enabled
        if (this.keyboardNavEnabled) {
            document.addEventListener('keydown', this.handleKeyboardNavigation.bind(this));
        }

        // this.swiper.on('autoplayStart', () => {
        //     console.log('Autoplay started');
        // });

        // this.swiper.on('autoplayStop', () => {
        //     console.log('Autoplay stopped');
        // });

        // this.swiper.on('slideChange', () => {
        //     console.log(`Slide changed to: ${this.swiper.activeIndex}`);
        // });

    }

    // Define updateCursorAttributes as a method of the class
    updateCursorAttributes(swiperInstance) {
        const slides = Array.from(swiperInstance.slides);

        slides.forEach((slide) => {
            const link = slide.querySelector('a');
            if (link) {
                link.removeAttribute('data-cursor');
                link.removeAttribute('data-cursor-text');
            }
        });

        const activeSlide = slides.find((slide) =>
            slide.classList.contains('swiper-slide-active')
        );

        if (activeSlide) {
            const activeLink = activeSlide.querySelector('a');
            if (activeLink) {
                activeLink.setAttribute('data-cursor', '');
                activeLink.setAttribute('data-cursor-text', this.dataCursorText); // Use the class property
            }
        }
    }

    createPopup() {
        if (!document.querySelector(this.options.popupSelector)) {
            const popup = document.createElement('div');
            popup.className = this.options.popupSelector.replace('.', '');
            popup.style.display = 'none';
            popup.style.position = 'fixed';

            const img = document.createElement('img');
            img.alt = 'Popup Image';

            const closeButton = document.createElement('button');
            closeButton.className = this.options.closeButtonSelector.replace('.', '');
            closeButton.textContent = 'Close';

            // Create a container for navigation buttons
            const navContainer = document.createElement('div');
            navContainer.className = 'popup-nav-container';

            const nextButton = document.createElement('button');
            nextButton.className = 'popup-next';
            // nextButton.textContent = 'Next';
            nextButton.innerHTML = '<span class="fill" style="transition-duration: 100ms; left: 65.5px; top: 26.0781px; width: 0px; height: 0px;"></span><svg class="arrow" width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H17M17 7L11 1M17 7L11 13"></path></svg><svg class="circle" viewBox="0 0 65 66" xmlns="http://www.w3.org/2000/svg"><path d="m64.045 33.953c0.5267 0 0.9537-0.427 0.9537-0.9537 0-0.5268-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m63.405 27.596c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m61.567 21.674c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9538-0.9538-0.9538s-0.9538 0.4271-0.9538 0.9538c0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m58.658 16.316c0.5267 0 0.9537-0.427 0.9537-0.9538 0-0.5267-0.427-0.9537-0.9537-0.9537-0.5268 0-0.9538 0.427-0.9538 0.9537 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m54.806 11.647c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.95375-0.9538-0.95375-0.5267 0-0.9537 0.42705-0.9537 0.95375 0 0.5268 0.427 0.9538 0.9537 0.9538z" fill="#AF1917"></path><path d="m50.138 7.7956c0.5268 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.427-0.95378-0.9538-0.95378-0.5267 0-0.9537 0.42702-0.9537 0.95378 0 0.52675 0.427 0.95377 0.9537 0.95377z" fill="#AF1917"></path><path d="m44.778 4.8872c0.5268 0 0.9538-0.42702 0.9538-0.95378s-0.427-0.95378-0.9538-0.95378c-0.5267 0-0.9538 0.42702-0.9538 0.95378s0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m38.858 3.0489c0.5268 0 0.9538-0.42702 0.9538-0.95378 0-0.52675-0.427-0.95377-0.9538-0.95377s-0.9538 0.42702-0.9538 0.95377c0 0.52676 0.427 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m32.5 2.4076c0.5268 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.427-0.95378-0.9538-0.95378-0.5267 0-0.9538 0.42702-0.9538 0.95378 0 0.52675 0.4271 0.95377 0.9538 0.95377z" fill="#AF1917"></path><path d="m26.142 3.0489c0.5268 0 0.9538-0.42702 0.9538-0.95378 0-0.52675-0.427-0.95377-0.9538-0.95377-0.5267 0-0.9538 0.42702-0.9538 0.95377 0 0.52676 0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m20.221 4.8872c0.5268 0 0.9538-0.42702 0.9538-0.95378s-0.427-0.95378-0.9538-0.95378c-0.5267 0-0.9538 0.42702-0.9538 0.95378s0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m14.862 7.7956c0.5267 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.4271-0.95378-0.9538-0.95378-0.5268 0-0.9538 0.42702-0.9538 0.95378 0 0.52675 0.427 0.95377 0.9538 0.95377z" fill="#AF1917"></path><path d="m10.194 11.647c0.5267 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.4271-0.95375-0.9538-0.95375-0.52676 0-0.95378 0.42705-0.95378 0.95375 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m6.3418 16.316c0.52675 0 0.95377-0.427 0.95377-0.9538 0-0.5267-0.42702-0.9537-0.95377-0.9537-0.52676 0-0.95378 0.427-0.95378 0.9537 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m3.4334 21.674c0.52676 0 0.95378-0.427 0.95378-0.9538 0-0.5267-0.42702-0.9538-0.95378-0.9538s-0.95378 0.4271-0.95378 0.9538c0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m1.5951 27.596c0.52676 0 0.95378-0.427 0.95378-0.9537 0-0.5268-0.42702-0.9538-0.95378-0.9538-0.52675 0-0.95377 0.427-0.95377 0.9538 0 0.5267 0.42702 0.9537 0.95377 0.9537z" fill="#AF1917"></path><path d="m0.95378 33.953c0.52675 0 0.95377-0.427 0.95377-0.9537 0-0.5268-0.42702-0.9538-0.95377-0.9538-0.52676 0-0.95378 0.427-0.95378 0.9538 0 0.5267 0.42702 0.9537 0.95378 0.9537z" fill="#AF1917"></path><path d="m1.5951 40.312c0.52676 0 0.95378-0.427 0.95378-0.9538s-0.42702-0.9538-0.95378-0.9538c-0.52675 0-0.95377 0.427-0.95377 0.9538s0.42702 0.9538 0.95377 0.9538z" fill="#AF1917"></path><path d="m3.4334 46.232c0.52676 0 0.95378-0.4271 0.95378-0.9538 0-0.5268-0.42702-0.9538-0.95378-0.9538s-0.95378 0.427-0.95378 0.9538c0 0.5267 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m6.3418 51.591c0.52675 0 0.95377-0.427 0.95377-0.9538 0-0.5267-0.42702-0.9538-0.95377-0.9538-0.52676 0-0.95378 0.4271-0.95378 0.9538 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m10.194 56.26c0.5267 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.4271-0.9538-0.9538-0.9538-0.52676 0-0.95378 0.427-0.95378 0.9538 0 0.5267 0.42702 0.9537 0.95378 0.9537z" fill="#AF1917"></path><path d="m14.862 60.112c0.5267 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.4271-0.9538-0.9538-0.9538-0.5268 0-0.9538 0.4271-0.9538 0.9538 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m20.221 63.02c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m26.142 64.859c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m32.5 65.499c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9537-0.9538-0.9537-0.5267 0-0.9538 0.427-0.9538 0.9537 0 0.5268 0.4271 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m38.858 64.859c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538s-0.9538 0.427-0.9538 0.9538c0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m44.778 63.02c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m50.138 60.112c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9537 0.4271-0.9537 0.9538 0 0.5268 0.427 0.9538 0.9537 0.9538z" fill="#AF1917"></path><path d="m54.806 56.26c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9537 0.427-0.9537 0.9538 0 0.5267 0.427 0.9537 0.9537 0.9537z" fill="#AF1917"></path><path d="m58.658 51.591c0.5267 0 0.9537-0.427 0.9537-0.9538 0-0.5267-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.4271-0.9538 0.9538 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m61.567 46.232c0.5268 0 0.9538-0.4271 0.9538-0.9538 0-0.5268-0.427-0.9538-0.9538-0.9538s-0.9538 0.427-0.9538 0.9538c0 0.5267 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m63.405 40.312c0.5268 0 0.9538-0.427 0.9538-0.9538s-0.427-0.9538-0.9538-0.9538c-0.5267 0-0.9538 0.427-0.9538 0.9538s0.4271 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m64.045 33.953c0.5267 0 0.9537-0.427 0.9537-0.9537 0-0.5268-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917" <="" svg=""></path></svg>';

            const prevButton = document.createElement('button');
            prevButton.className = 'popup-prev';
            // prevButton.textContent = 'Previous';
            prevButton.innerHTML = '<span class="fill" style="transition-duration: 100ms; left: 65.5px; top: 26.0781px; width: 0px; height: 0px;"></span><svg class="arrow" width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H17M17 7L11 1M17 7L11 13"></path></svg><svg class="circle" viewBox="0 0 65 66" xmlns="http://www.w3.org/2000/svg"><path d="m64.045 33.953c0.5267 0 0.9537-0.427 0.9537-0.9537 0-0.5268-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m63.405 27.596c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m61.567 21.674c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9538-0.9538-0.9538s-0.9538 0.4271-0.9538 0.9538c0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m58.658 16.316c0.5267 0 0.9537-0.427 0.9537-0.9538 0-0.5267-0.427-0.9537-0.9537-0.9537-0.5268 0-0.9538 0.427-0.9538 0.9537 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m54.806 11.647c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.95375-0.9538-0.95375-0.5267 0-0.9537 0.42705-0.9537 0.95375 0 0.5268 0.427 0.9538 0.9537 0.9538z" fill="#AF1917"></path><path d="m50.138 7.7956c0.5268 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.427-0.95378-0.9538-0.95378-0.5267 0-0.9537 0.42702-0.9537 0.95378 0 0.52675 0.427 0.95377 0.9537 0.95377z" fill="#AF1917"></path><path d="m44.778 4.8872c0.5268 0 0.9538-0.42702 0.9538-0.95378s-0.427-0.95378-0.9538-0.95378c-0.5267 0-0.9538 0.42702-0.9538 0.95378s0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m38.858 3.0489c0.5268 0 0.9538-0.42702 0.9538-0.95378 0-0.52675-0.427-0.95377-0.9538-0.95377s-0.9538 0.42702-0.9538 0.95377c0 0.52676 0.427 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m32.5 2.4076c0.5268 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.427-0.95378-0.9538-0.95378-0.5267 0-0.9538 0.42702-0.9538 0.95378 0 0.52675 0.4271 0.95377 0.9538 0.95377z" fill="#AF1917"></path><path d="m26.142 3.0489c0.5268 0 0.9538-0.42702 0.9538-0.95378 0-0.52675-0.427-0.95377-0.9538-0.95377-0.5267 0-0.9538 0.42702-0.9538 0.95377 0 0.52676 0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m20.221 4.8872c0.5268 0 0.9538-0.42702 0.9538-0.95378s-0.427-0.95378-0.9538-0.95378c-0.5267 0-0.9538 0.42702-0.9538 0.95378s0.4271 0.95378 0.9538 0.95378z" fill="#AF1917"></path><path d="m14.862 7.7956c0.5267 0 0.9538-0.42702 0.9538-0.95377 0-0.52676-0.4271-0.95378-0.9538-0.95378-0.5268 0-0.9538 0.42702-0.9538 0.95378 0 0.52675 0.427 0.95377 0.9538 0.95377z" fill="#AF1917"></path><path d="m10.194 11.647c0.5267 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.4271-0.95375-0.9538-0.95375-0.52676 0-0.95378 0.42705-0.95378 0.95375 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m6.3418 16.316c0.52675 0 0.95377-0.427 0.95377-0.9538 0-0.5267-0.42702-0.9537-0.95377-0.9537-0.52676 0-0.95378 0.427-0.95378 0.9537 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m3.4334 21.674c0.52676 0 0.95378-0.427 0.95378-0.9538 0-0.5267-0.42702-0.9538-0.95378-0.9538s-0.95378 0.4271-0.95378 0.9538c0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m1.5951 27.596c0.52676 0 0.95378-0.427 0.95378-0.9537 0-0.5268-0.42702-0.9538-0.95378-0.9538-0.52675 0-0.95377 0.427-0.95377 0.9538 0 0.5267 0.42702 0.9537 0.95377 0.9537z" fill="#AF1917"></path><path d="m0.95378 33.953c0.52675 0 0.95377-0.427 0.95377-0.9537 0-0.5268-0.42702-0.9538-0.95377-0.9538-0.52676 0-0.95378 0.427-0.95378 0.9538 0 0.5267 0.42702 0.9537 0.95378 0.9537z" fill="#AF1917"></path><path d="m1.5951 40.312c0.52676 0 0.95378-0.427 0.95378-0.9538s-0.42702-0.9538-0.95378-0.9538c-0.52675 0-0.95377 0.427-0.95377 0.9538s0.42702 0.9538 0.95377 0.9538z" fill="#AF1917"></path><path d="m3.4334 46.232c0.52676 0 0.95378-0.4271 0.95378-0.9538 0-0.5268-0.42702-0.9538-0.95378-0.9538s-0.95378 0.427-0.95378 0.9538c0 0.5267 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m6.3418 51.591c0.52675 0 0.95377-0.427 0.95377-0.9538 0-0.5267-0.42702-0.9538-0.95377-0.9538-0.52676 0-0.95378 0.4271-0.95378 0.9538 0 0.5268 0.42702 0.9538 0.95378 0.9538z" fill="#AF1917"></path><path d="m10.194 56.26c0.5267 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.4271-0.9538-0.9538-0.9538-0.52676 0-0.95378 0.427-0.95378 0.9538 0 0.5267 0.42702 0.9537 0.95378 0.9537z" fill="#AF1917"></path><path d="m14.862 60.112c0.5267 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.4271-0.9538-0.9538-0.9538-0.5268 0-0.9538 0.4271-0.9538 0.9538 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m20.221 63.02c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m26.142 64.859c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m32.5 65.499c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9537-0.9538-0.9537-0.5267 0-0.9538 0.427-0.9538 0.9537 0 0.5268 0.4271 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m38.858 64.859c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538s-0.9538 0.427-0.9538 0.9538c0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m44.778 63.02c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.4271 0.9537 0.9538 0.9537z" fill="#AF1917"></path><path d="m50.138 60.112c0.5268 0 0.9538-0.427 0.9538-0.9538 0-0.5267-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9537 0.4271-0.9537 0.9538 0 0.5268 0.427 0.9538 0.9537 0.9538z" fill="#AF1917"></path><path d="m54.806 56.26c0.5268 0 0.9538-0.427 0.9538-0.9537 0-0.5268-0.427-0.9538-0.9538-0.9538-0.5267 0-0.9537 0.427-0.9537 0.9538 0 0.5267 0.427 0.9537 0.9537 0.9537z" fill="#AF1917"></path><path d="m58.658 51.591c0.5267 0 0.9537-0.427 0.9537-0.9538 0-0.5267-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.4271-0.9538 0.9538 0 0.5268 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m61.567 46.232c0.5268 0 0.9538-0.4271 0.9538-0.9538 0-0.5268-0.427-0.9538-0.9538-0.9538s-0.9538 0.427-0.9538 0.9538c0 0.5267 0.427 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m63.405 40.312c0.5268 0 0.9538-0.427 0.9538-0.9538s-0.427-0.9538-0.9538-0.9538c-0.5267 0-0.9538 0.427-0.9538 0.9538s0.4271 0.9538 0.9538 0.9538z" fill="#AF1917"></path><path d="m64.045 33.953c0.5267 0 0.9537-0.427 0.9537-0.9537 0-0.5268-0.427-0.9538-0.9537-0.9538-0.5268 0-0.9538 0.427-0.9538 0.9538 0 0.5267 0.427 0.9537 0.9538 0.9537z" fill="#AF1917" <="" svg=""></path></svg>';

            // Append buttons to the nav container
            navContainer.appendChild(prevButton);
            navContainer.appendChild(nextButton);

            // Append elements to the popup
            popup.appendChild(img);
            popup.appendChild(closeButton);
            popup.appendChild(navContainer); // Add nav container here
            document.body.appendChild(popup);

            // Check if nav is enabled or not
            if (!this.options.enableNav) {

                // console.log('enable nav');

                this.disableNavigation(navContainer);

            }
        }
    }

    handleKeyboardNavigation(event) {
        if (this.popup.style.display === 'flex') {

            if (event.key === 'Escape') {
                this.closePopup();
                return;
            }

            // Stop autoplay immediately
            if (this.swiper && this.swiper.autoplay) {
                this.swiper.autoplay.stop();
            }

            // Clear any existing timeout
            if (this.autoplayTimeout) {
                clearTimeout(this.autoplayTimeout);
                this.autoplayTimeout = null;
            }

            // Handle navigation
            if (event.key === 'ArrowRight') {
                this.swiper.slideNext(); // Go to the next slide
            } else if (event.key === 'ArrowLeft') {
                this.swiper.slidePrev(); // Go to the previous slide
            }

            // Restart autoplay after a controlled delay
            this.autoplayTimeout = setTimeout(() => {
                if (this.swiper && this.swiper.autoplay) {
                    this.swiper.autoplay.start();
                }
            }, this.autoplayPauseDuration); // Delay in milliseconds (e.g., 5000)
        }
    }

    // Touch event to handle swipe start
    handleTouchStart(event) {
        if (this.options.enableTouchNav) {
            this.touchStartX = event.changedTouches[0].screenX;
        }
    }

    // Touch event to handle swipe end
    handleTouchEnd(event) {
        if (this.options.enableTouchNav) {
            this.touchEndX = event.changedTouches[0].screenX;

            if (this.touchEndX > this.touchStartX) {
                this.showPreviousImage();
            } else if (this.touchEndX < this.touchStartX) {
                this.showNextImage();
            }
        }
    }

    pauseAutoplayCompletely() {
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.stop();
        }
        clearTimeout(this.autoplayTimeout); // Clear any pending timeouts
        this.autoplayTimeout = null;
    }

    // Method to pause autoplay for 5 seconds
    autoplayDelay() {
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.stop(); // Stop autoplay immediately
            clearTimeout(this.autoplayTimeout);
            this.autoplayTimeout = setTimeout(() => {
                this.swiper.autoplay.start(); // Restart autoplay after the specified duration
            }, this.autoplayPauseDuration); // Use the configured duration
        }
    }

    closePopup() {
        this.popup.style.display = 'none';
        this.popupImage.src = ''; // Clear the image when closing

        // Restart Swiper autoplay when the popup closes
        if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.start();
        }

        // Unlock the scroll by removing the lock-scroll class
        const html = document.querySelectorAll('html');
        html[0].classList.remove('lock-scroll');

    }

    handleBackgroundClick(event) {
        if (event.target === this.popup) {
            this.closePopup();

            // Restart Swiper autoplay when the popup closes
            if (this.swiper && this.swiper.autoplay) {
                this.swiper.autoplay.start();
            }

        }
    }

    showPreviousImage() {
        this.swiper.slidePrev();
    }

    showNextImage() {
        this.swiper.slideNext();
    }

    updatePopupImage(isNext = true) {
        setTimeout(() => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            const imageUrl = activeSlide.querySelector('img').getAttribute('src');
            this.popupImage.src = imageUrl;
            // console.log('Updated Image:', imageUrl);
        }, 100);
    }

    openPopup(event) {
        event.preventDefault();
        const imageUrl = event.currentTarget.querySelector('img').getAttribute('src');
        this.popupImage.src = imageUrl;
        this.popup.style.display = 'flex';


        // Store the current index when the popup is opened
        this.currentIndex = this.swiper.realIndex;

        // // Stop Swiper autoplay when the popup opens
        // if (this.swiper && this.swiper.autoplay) {
        //     this.swiper.autoplay.stop();
        // }

        // Lock the scroll by adding the lock-scroll class
        const html = document.querySelectorAll('html');
        html[0].classList.add('lock-scroll');
        initializeButtonEffect();

    }
}

const swiperSliderGallery = (selector, dataCursorText) => {
    const swiperSliders = document.querySelectorAll(selector);


    swiperSliders.forEach((slider) => {
        let nearestSlider = slider.closest('section');
        const pagination = slider.querySelector('.swiper-pagination');
        const prev = nearestSlider.querySelector('.swiper-button-prev');
        const next = nearestSlider.querySelector('.swiper-button-next');
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(slider, {
            modules: [Autoplay, Navigation],
            loop: true,
            centeredSlides: true,
            pagination: {
                el: slidesCount > 1 ? pagination : null,
                clickable: true,
            },
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            spaceBetween: 0,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
                768: {
                    slidesPerView: 3,
                },
            },
            on: {
                init: function () {
                    const imagePopupInstance = new ImagePopup({
                        swiperInstance: this,  // Pass the swiper instance to ImagePopup
                        // dataCursorText: 'dog', // You can pass this dynamically
                    });
                    imagePopupInstance.updateCursorAttributes(this);
                },
                slideChangeTransitionEnd: function () {
                    const imagePopupInstance = new ImagePopup({
                        swiperInstance: this, // Pass the swiper instance to ImagePopup
                        // dataCursorText: 'dog', // You can pass this dynamically
                    });
                    imagePopupInstance.updateCursorAttributes(this);
                },
            },
        });

        // // Initialize ImagePopup with the current Swiper instance
        // new ImagePopup({
        //     popupSelector: '.popup',
        //     popupImageSelector: 'img',
        //     closeButtonSelector: '.popup-close',
        //     linkSelector: '.swiper-slide a',
        //     swiperInstance: swiper,
        //     autoplay: false,
        //     autoplayValue: 5000,
        //     autoplayDelay: 5000,
        //     keyboardNavEnabled: true,
        //     enableNav: true,
        //     enableTouchNav: true,
        //     dataCursorText: 'dog',
        // });
    });
};

// Call the function to initialize your Swiper gallery
swiperSliderGallery('.swiper-slider-gallery');
